import ClienteService from '../../../business-api/ClienteService'

import ApoliceService from '../../../business-api/ApoliceService'

import VwClienteAcessoApoliceService from '../../../business-api/VwClienteAcessoApoliceService'

//.import HARDCODE from '../../../business-const/HardCode/HardCode'

//import {
//    formataAnoMesInteiroComBarra,
//} from '../../../business-components/Date/Date'

import {
    mensagemErroErro
} from '../../../business-components/Toastr/Toastr'

//import {
//    round
//} from '../../../business-components/round/round'

//import {
//    pesquisaList,
//    pesquisaIndexList,
//} from '../../../business-rules/List/ListService'

//import {
//    sortAsc
//} from '../../../business-components/Sort/Sort'



export const getApoliceList = async ( variaveisGlobais, filtroList ) => {

    const vwClienteAcessoApoliceService = new VwClienteAcessoApoliceService()

    try {
        const response = await vwClienteAcessoApoliceService.buscarApoliceList(variaveisGlobais, filtroList)

        return response.data

    } catch (erro) {

        mensagemErroErro(erro)
        
        return []
    }
}

export const getSumApolice = async ( variaveisGlobais, campoAgrupamento, filtroList ) => {

    const vwClienteAcessoApoliceService = new VwClienteAcessoApoliceService()

    try {
        const response = await vwClienteAcessoApoliceService.sumApolice(variaveisGlobais, campoAgrupamento, filtroList)

        return response.data

    } catch (erro) {

        mensagemErroErro(erro)
        
        return []
    }
}



/*
export const trataApolicesList = (list, ordenarPorAgrupamento, agrupamentoAnoMes, tipoList, primeiros) => {

    const graficoLista = {
        grafico: {
            data: [],
            data2: [],
            categories: [],
        },
        lista: [],
        listaClick: [],
    }

    let agrupamento

    let indexLista

    let qtdeApolicesTotal
    let valorPremioAnualizadoTotal

    list?.forEach((linhaList, indexList) => {

        agrupamento =
            tipoList
                ?
                    pesquisaList(tipoList, linhaList.agrupamento).descricao
                :
                    linhaList.agrupamento

        indexLista = pesquisaIndexList(graficoLista.lista, agrupamento)

        if (indexLista === null) {
            
            graficoLista.lista.push(
                {
                    id: agrupamento,
                    filtro: linhaList.agrupamento,
                    qtdeApolices: linhaList.qtdeApolices,
                    qtdeApolicesAtiva:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceAtiva
                            ?
                                linhaList.qtdeApolices
                            :
                                0,
                    qtdeApolicesCancelada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceCancelada ||
                        linhaList.statusApolice === HARDCODE.idStatusApoliceSubstituida ||
                        linhaList.statusApolice === HARDCODE.idStatusApoliceAnulada
                            ?
                                linhaList.qtdeApolices
                            :
                                0,
                    qtdeApolicesRejeitada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceRejeitada
                            ?
                                linhaList.qtdeApolices
                            :
                                0,
                    qtdeApolicesConvertida:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceConvertida
                            ?
                                linhaList.qtdeApolices
                            :
                                0,
                    qtdeApolicesTerminada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceTerminada
                            ?
                                linhaList.qtdeApolices
                            :
                                0,
                    qtdeApolicesSinistrada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceSinistrada
                            ?
                                linhaList.qtdeApolices
                            :
                                0,
                    valorPremioAnualizado: linhaList.valorPremioAnualizado,
                    valorPremioAnualizadoAtiva:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceAtiva
                            ?
                                linhaList.valorPremioAnualizado
                            :
                                0,
                    valorPremioAnualizadoCancelada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceCancelada ||
                        linhaList.statusApolice === HARDCODE.idStatusApoliceSubstituida ||
                        linhaList.statusApolice === HARDCODE.idStatusApoliceAnulada
                            ?
                                linhaList.valorPremioAnualizado
                            :
                                0,
                    valorPremioAnualizadoRejeitada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceRejeitada
                            ?
                                linhaList.valorPremioAnualizado
                            :
                                0,
                    valorPremioAnualizadoConvertida:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceConvertida
                            ?
                                linhaList.valorPremioAnualizado
                            :
                                0,
                    valorPremioAnualizadoTerminada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceTerminada
                            ?
                                linhaList.valorPremioAnualizado
                            :
                                0,
                    valorPremioAnualizadoSinistrada:
                        linhaList.statusApolice === HARDCODE.idStatusApoliceSinistrada
                            ?
                                linhaList.valorPremioAnualizado
                            :
                                0,
                }
            )

            indexLista = graficoLista.lista.length - 1

        } else {

            graficoLista.lista[indexLista].qtdeApolices += linhaList.qtdeApolices
            graficoLista.lista[indexLista].qtdeApolicesAtiva +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceAtiva
                    ?
                        linhaList.qtdeApolices
                    :
                        0
            graficoLista.lista[indexLista].qtdeApolicesCancelada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceCancelada ||
                linhaList.statusApolice === HARDCODE.idStatusApoliceSubstituida ||
                linhaList.statusApolice === HARDCODE.idStatusApoliceAnulada
                    ?
                        linhaList.qtdeApolices
                    :
                        0
            graficoLista.lista[indexLista].qtdeApolicesRejeitada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceRejeitada
                    ?
                        linhaList.qtdeApolices
                    :
                        0
            graficoLista.lista[indexLista].qtdeApolicesConvertida +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceConvertida
                    ?
                        linhaList.qtdeApolices
                    :
                        0
            graficoLista.lista[indexLista].qtdeApolicesTerminada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceTerminada
                    ?
                        linhaList.qtdeApolices
                    :
                        0
            graficoLista.lista[indexLista].qtdeApolicesSinistrada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceSinistrada
                    ?
                        linhaList.qtdeApolices
                    :
                        0
            graficoLista.lista[indexLista].valorPremioAnualizado += linhaList.valorPremioAnualizado
            graficoLista.lista[indexLista].valorPremioAnualizadoAtiva +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceAtiva
                    ?
                        linhaList.valorPremioAnualizado
                    :
                        0
            graficoLista.lista[indexLista].valorPremioAnualizadoCancelada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceCancelada ||
                linhaList.statusApolice === HARDCODE.idStatusApoliceSubstituida ||
                linhaList.statusApolice === HARDCODE.idStatusApoliceAnulada
                    ?
                        linhaList.valorPremioAnualizado
                    :
                        0
            graficoLista.lista[indexLista].valorPremioAnualizadoRejeitada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceRejeitada
                    ?
                        linhaList.valorPremioAnualizado
                    :
                        0
            graficoLista.lista[indexLista].valorPremioAnualizadoConvertida +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceConvertida
                    ?
                        linhaList.valorPremioAnualizado
                    :
                        0
            graficoLista.lista[indexLista].valorPremioAnualizadoTerminada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceTerminada
                    ?
                        linhaList.valorPremioAnualizado
                    :
                        0
            graficoLista.lista[indexLista].valorPremioAnualizadoSinistrada +=
                linhaList.statusApolice === HARDCODE.idStatusApoliceSinistrada
                    ?
                        linhaList.valorPremioAnualizado
                    :
                        0
        }

        qtdeApolicesTotal += graficoLista.lista[indexLista].qtdeApolices
        valorPremioAnualizadoTotal += graficoLista.lista[indexLista].valorPremioAnualizado

        graficoLista.lista[indexLista].ordem =
            ordenarPorAgrupamento
                ?
                    agrupamento
                :
                    graficoLista.lista[indexLista].valorPremioAnualizado * -1
    })

    graficoLista.lista = sortAsc(graficoLista.lista)

    let indexGrafico = 0

    const tamGraficoLista = graficoLista.lista.length

    graficoLista.lista?.forEach((linhaLista, indexLista) => {

        if (
                (primeiros && indexGrafico < 10) ||
                (!primeiros && indexLista > (tamGraficoLista - 1 - 10))

        ) {

            graficoLista.grafico.data.push(
                linhaLista.valorPremioAnualizado
            )
            
            graficoLista.grafico.data2.push(
                linhaLista.qtdeApolices
            )
            
            graficoLista.grafico.categories.push(
                agrupamentoAnoMes ? formataAnoMesInteiroComBarra(linhaLista.id) : linhaLista.id
            )

            graficoLista.listaClick.push(
                linhaLista
            )
        }

        graficoLista.lista[indexLista].percQtdeApolicesTotal =
            qtdeApolicesTotal
                ?
                    round(graficoLista.lista[indexLista].qtdeApolices /
                        qtdeApolicesTotal * 100, 2)
                :
                    ''

        graficoLista.lista[indexLista].percQtdeApolicesAtiva =
            graficoLista.lista[indexLista].qtdeApolices
                ?
                    round(graficoLista.lista[indexLista].qtdeApolicesAtiva /
                        graficoLista.lista[indexLista].qtdeApolices * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percQtdeApolicesCancelada =
            graficoLista.lista[indexLista].qtdeApolices
                ?
                    round(graficoLista.lista[indexLista].qtdeApolicesCancelada /
                        graficoLista.lista[indexLista].qtdeApolices * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percQtdeApolicesRejeitada =
            graficoLista.lista[indexLista].qtdeApolices
                ?
                    round(graficoLista.lista[indexLista].qtdeApolicesRejeitada /
                        graficoLista.lista[indexLista].qtdeApolices * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percQtdeApolicesConvertida =
            graficoLista.lista[indexLista].qtdeApolices
                ?
                    round(graficoLista.lista[indexLista].qtdeApolicesConvertida /
                        graficoLista.lista[indexLista].qtdeApolices * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percQtdeApolicesTerminada =
            graficoLista.lista[indexLista].qtdeApolices
                ?
                    round(graficoLista.lista[indexLista].qtdeApolicesTerminada /
                        graficoLista.lista[indexLista].qtdeApolices * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percQtdeApolicesSinistrada =
            graficoLista.lista[indexLista].qtdeApolices
                ?
                    round(graficoLista.lista[indexLista].qtdeApolicesSinistrada /
                        graficoLista.lista[indexLista].qtdeApolices * 100, 2)
                :
                    ''

        graficoLista.lista[indexLista].percValorPremioAnualizadoTotal =
            valorPremioAnualizadoTotal
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizado /
                        valorPremioAnualizadoTotal * 100, 2)
                :
                    ''

        graficoLista.lista[indexLista].percValorPremioAnualizadoAtiva =
            graficoLista.lista[indexLista].valorPremioAnualizado
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizadoAtiva /
                        graficoLista.lista[indexLista].valorPremioAnualizado * 100, 2)
                :

        graficoLista.lista[indexLista].percValorPremioAnualizadoCancelada =
            graficoLista.lista[indexLista].valorPremioAnualizado
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizadoCancelada /
                        graficoLista.lista[indexLista].valorPremioAnualizado * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percValorPremioAnualizadoRejeitada =
            graficoLista.lista[indexLista].valorPremioAnualizado
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizadoRejeitada /
                        graficoLista.lista[indexLista].valorPremioAnualizado * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percValorPremioAnualizadoConvertida =
            graficoLista.lista[indexLista].valorPremioAnualizado
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizadoConvertida /
                        graficoLista.lista[indexLista].valorPremioAnualizado * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percValorPremioAnualizadoTerminada =
            graficoLista.lista[indexLista].valorPremioAnualizado
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizadoTerminada /
                        graficoLista.lista[indexLista].valorPremioAnualizado * 100, 2)
                :
                    ''
        graficoLista.lista[indexLista].percValorPremioAnualizadoSinistrada =
            graficoLista.lista[indexLista].valorPremioAnualizado
                ?
                    round(graficoLista.lista[indexLista].valorPremioAnualizadoSinistrada /
                        graficoLista.lista[indexLista].valorPremioAnualizado * 100, 2)
                :
                    ''
        
        indexGrafico++
    })

    return graficoLista
}
*/



export const putApoliceAgenteList = /*async */( variaveisGlobais, idArquivo, jsonApoliceAgenteList) => {

    const apoliceService = new ApoliceService()

    try {

        const response = /*await */apoliceService.atualizarApoliceAgenteList(variaveisGlobais,
            ClienteService.obterUsuarioClienteSelecionado(variaveisGlobais), idArquivo,
                JSON.stringify(jsonApoliceAgenteList))

        return response.data

    } catch (erro) {

        mensagemErroErro(erro)

        return 0
    }
}